import { cx } from "cva";
import React from "react";
import { BuildHtml } from "~/components/BuildHtml";
import {
  ReportPreviewDownloadButton,
  ReportPreviewDownloadButtonProps,
} from "~/components/ReportPreviewDownloadButton";
import { sidecarTagToClassNameMap } from "~/components/Sidecar/sidecarTagToClassNameMap";
import { sidecarTagToReactConverters } from "~/components/Sidecar/sidecarTagToReactConverters";

export type ContentSummarySidecarProps = {
  /** Expected html string to be rendered underneath the headline "About This Report" */
  contentHtml: string;
  downloadButtonProps: ReportPreviewDownloadButtonProps;
};

export const ContentSummarySidecar: React.FC<ContentSummarySidecarProps> = ({
  contentHtml,
  downloadButtonProps,
}) => (
  <div
    data-testid="parent-div"
    className={cx("relative", "text-body-small", "bg-white")}
  >
    {!!contentHtml && (
      <BuildHtml
        html={contentHtml}
        tagToClassNameMap={sidecarTagToClassNameMap}
        tagToReactConverters={sidecarTagToReactConverters}
      />
    )}

    <div className="flex flex-col gap-m">
      <ReportPreviewDownloadButton {...downloadButtonProps} />
    </div>
  </div>
);
